<template>
  <div>
    <Navbar></Navbar>

    <div class="container mt-3 mt-lg-5">

      <!-- TITLE-->
      <div class="row mb-5">
        <div class="col-md-12 mb-3">
          <router-link to="/admin/gradients" class="btn btn-link btn-micint-xr ripple ripple-primary m-0">
            <i class="material-icons-outlined">arrow_left</i>
            Go back
          </router-link>
        </div>
        <div class="col-md-12 text-center">
          <h4 class="fw-bold">Create a <span class="text-gradient-animate">gradient</span></h4>
        </div>
      </div>

      <!-- FORM -->
      <div class="row justify-content-center mb-3">
        <div class="col-md-10 col-lg-8 mb-3">
          <div v-if="error" class="alert alert-danger mb-3">{{ error }}</div>
          <div class="card card-outline">
            <div class="card-header my-4">
              <div class="gradient gradient-sm" v-if="form.color3"
                   :style="{ 'background': 'linear-gradient' + '(to right,' + form.color1 + ',' + form.color2 + ',' + form.color3 + ')' }"></div>
              <div class="gradient gradient-sm" v-else
                   :style="{ 'background': 'linear-gradient' + '(to right,' + form.color1 + ',' + form.color2 + ')' }"></div>
            </div>
            <div class="card-body mt-3">
              <form action="#" @submit.prevent="onSubmit" class="row">
                <div class="col-md-12 mb-3">
                  <label for="input-name" class="mb-2">Gradient name</label>
                  <input v-model="form.name" type="text" class="form-control form-big-height" id="input-name"
                         placeholder="Fire Red, Leaf Green" required autocomplete="off"
                         autofocus>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="input-color-1" class="mb-2">Color 1</label>
                  <div class="d-flex align-items-center">
                    <color-picker v-model="form.color1" mode="hex"></color-picker>
                    <input type="text" class="form-control form-big-height ms-2" id="input-color-1"
                           v-model="form.color1">
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="input-color-2" class="mb-2">Color 2</label>
                  <div class="d-flex align-items-center">
                    <color-picker v-model="form.color2" mode="hex"></color-picker>
                    <input type="text" class="form-control form-big-height ms-2" id="input-color-2"
                           v-model="form.color2">
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="input-color-3" class="mb-2">Color 3 (Optional)</label>
                  <div class="d-flex align-items-center">
                    <color-picker v-model="form.color3" mode="hex"></color-picker>
                    <input type="text" class="form-control form-big-height ms-2" id="input-color-3"
                           v-model="form.color3">
                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="input-color-keywords" class="mb-2">Color keywords</label>
                  <v-select v-model="form.colorKeywords" class="" id="input-color-keywords" multiple
                            :options="['Red', 'Blue', 'Green', 'Cyan', 'Pink', 'Yellow', 'Black', 'White', 'Grey', 'Orange', 'Purple', 'Brown']"/>
                </div>
                <div class="col-md-12 text-end mt-3">
                  <button class="btn btn-primary btn-xs-full-width btn-micint-x ripple p-3" @click="onSubmit">
                    <i class="material-icons-outlined me-2">save</i>
                    Save gradient
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "@/components/includes/Navbar";
import Footer from "@/components/includes/Footer";
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  name: 'FormNewGradient',
  components: {Footer, Navbar},
  metaInfo: {
    title: 'Create Gradient',
  },
  data() {
    return {
      form: {},
      gradientUID: null,
      error: null,
    }
  },
  methods: {
    onSubmit() {
      // TODO: CHECK CODE XD
      const db = firebase.firestore()
      let color3 = this.form.color3

      if (color3) {
        if (this.gradientUID) {
          db.collection('gradients').doc(this.gradientUID).set({
            name: this.form.name,
            color1: this.form.color1,
            color2: this.form.color2,
            color3: this.form.color3,
            colorKeywords: this.form.colorKeywords,
            createdAt: new Date(Date.now()).toLocaleString()
          })
          this.$swal({
            customClass: {
              confirmButton: 'btn btn-primary btn-w-100',
            },
            buttonsStyling: false,

            showConfirmButton: true,
            icon: 'success',
            title: '3 colors gradient saved!',
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.replace("/admin/gradients")
            }
          }).catch(err => {
            this.error = err.message
          })

        } else {
          const gradientUID = db.collection('gradients').doc()
          gradientUID.set(this.form)
          this.gradientUID = gradientUID.id
        }
      } else {
        if (this.gradientUID) {
          db.collection('gradients').doc(this.gradientUID).set({
            name: this.form.name,
            color1: this.form.color1,
            color2: this.form.color2,
            colorKeywords: this.form.colorKeywords,
            createdAt: new Date(Date.now()).toLocaleString()
          })

          this.$swal({
            customClass: {
              confirmButton: 'btn btn-primary btn-w-100',
            },
            buttonsStyling: false,

            showConfirmButton: true,
            icon: 'success',
            title: '2 colors gradient saved!',
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.replace("/admin/gradients")
            }
          }).catch(err => {
            this.error = err.message
          })

        } else {
          const gradientUID = db.collection('gradients').doc()
          gradientUID.set(this.form)
          this.gradientUID = gradientUID.id
        }
      }
    }
  }
}
</script>